import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };
    const { t } = useTranslation();
    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-3 col-8">
                    <div style={{ paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px" }}>
                       
                        <img src="./images/logo-maruthi.png" style={{ width: "10%" }} alt="logo" />
                        <span className="templename" >
                        {t("Temple_name")}
                        </span>
                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button 
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                    <LanguageSelector />
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-9 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                            {t("home")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                            {t("history")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.sreekrishnamaruthitemple.com/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                {t("onlinebooking")}
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                            {t("darsantime")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Adimayiruthal" className="menuitems" onClick={closeMenu}>
                            {t("adimayiruthal")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Administration" className="menuitems" onClick={closeMenu}>
                            {t("administration")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Gallery" className="menuitems" onClick={closeMenu}>
                            {t("gallery")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                            {t("contact")}
                            </Link>
                        </div>
                        <div className="boxes">
                            <LanguageSelector />
                        </div>

                    </div>
                </div>


            </div>
        </div>
    );
}

export default MainMenu;
